class Table {
  constructor() {
    this.tables = document.querySelectorAll("table")

    this.tables.forEach(t => {
      this.init(t)
    })
  }

  init(el) {
    if (el.classList.contains("table--data")) {
      this.initDataTable(el)
    } else if (el.classList.contains("table--alt")) {
      this.initAltTable(el)
    } else {
      this.initTable(el)
    }
  }

  initDataTable(el) {
    const wrapper = document.createElement("div")
    wrapper.classList.add("table__wrapper")

    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)

    // Set column widths
    let columnWidths = []

    el.querySelectorAll("thead tr").forEach(tr => {
      tr.querySelectorAll("th").forEach((th, index) => {
        if (!columnWidths[index]) {
          columnWidths[index] = th.clientWidth
        } else {
          if (th.clientWidth > columnWidths[index]) {
            columnWidths[index] = th.clientWidth
          }
        }
      })
    })

    el.querySelectorAll("tbody tr").forEach(tr => {
      tr.querySelectorAll("td").forEach((td, index) => {
        if (!columnWidths[index]) {
          columnWidths[index] = td.clientWidth
        } else {
          if (td.clientWidth > columnWidths[index]) {
            columnWidths[index] = td.clientWidth
          }
        }
      })
    })

    columnWidths.forEach((col, index) => {
      el.querySelectorAll(`thead tr th:nth-child(${index + 1})`).forEach(td => {
        td.style.minWidth = `${col}px`
      })

      el.querySelectorAll(`tbody tr td:nth-child(${index + 1})`).forEach(td => {
        td.style.minWidth = `${col}px`
      })
    })
  }

  initAltTable(el) {
    this.initTable(el)

    el.querySelectorAll("tbody tr td").forEach(td => {
      const wrapper = document.createElement("div")
      wrapper.classList.add("table--alt__wrapper")
      wrapper.textContent = td.textContent

      td.textContent = ""
      td.appendChild(wrapper)
    })
  }

  /**
   * Inserts the th headings into the data-column attributes for mobile view
   * el is a single <table> element
   */
  initTable(el) {
    let columnHeadings = []

    let rows = el.querySelectorAll("thead tr")
    rows.forEach(tr => {
      let headings = tr.querySelectorAll("th")
      headings.forEach((td, index) => {
        // cannot not use td.innerText for hidden content like accordions
        columnHeadings[index] = td.textContent
      })
    })

    columnHeadings.forEach((col, index) => {
      let line = el.querySelectorAll(`tbody tr td:nth-child(${index + 1})`)
      line.forEach(td => {
        td.setAttribute("data-column", col)
      })
    })
  }
}

export default function init() {
  new Table()
}
